import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '..';

export const selectCurrentOrganizationId = (state: RootState) =>
  state.organizations.organizations?.current?.id;
export const selectOrganizationsData = (state: RootState) => state.organizations.organizations;
export const selectOrganizationUsersData = (state: RootState) => state.organizations.users;
export const selectSelectedUserIdData = (state: RootState) => state.organizations.selectedUserId;

export const selectSubOrganizationsData = createSelector([selectOrganizationsData], (data) => {
  return {
    data: data.sub,
    rest: data.rest,
  };
});

export const selectSearchData = (state: RootState) => state.organizations.search;
export const selectOrganizationWebSocketStatus = (state: RootState) =>
  state.organizations.organizationHubStatus;
export const selectExternalApi = (state: RootState) => state.organizations.externalApi;
